/* global axios */
import ApiClient from './ApiClient';

class AgentAvailabilityAPI extends ApiClient {
  constructor() {
    super('agent_availabilities', { accountScoped: true });
  }

  // The current user's own availability (auto-creates an empty default).
  getMe() {
    return axios.get(`${this.url}/me`);
  }
}

export default new AgentAvailabilityAPI();
